import { Banner, Button, Link } from '@dev-spendesk/grapes';
import { Trans } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routes, routeFor } from 'src/core/constants/routes';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';
import { useHasAccessToMultiEntityConfig } from 'src/core/modules/app/layout/components/VerticalNavigation/useHasAccessToMultiEntityConfig';

import { useOrganisationSettings } from '../../hooks/useOrganisationSettings';

type Props = {
  className?: string;
};

export const MultiEntityHubSettingsMarketingBanner = ({ className }: Props) => {
  const { t } = useTranslation('global');
  const history = useHistory();
  const companyId = useCompanyId();
  const hasAccessToMultiEntityConfig = useHasAccessToMultiEntityConfig({
    isEnabled: true,
  });
  const organisationSettingsState = useOrganisationSettings();

  // do not show banner if no access to multi-entity config
  if (
    hasAccessToMultiEntityConfig.status !== 'success' ||
    !hasAccessToMultiEntityConfig.hasAccess
  ) {
    return null;
  }

  // do not show banner if compnay has at least one cross-entity cost center
  if (
    organisationSettingsState.status !== 'success' ||
    organisationSettingsState.data.some(
      (setting) => setting.type === 'cross-entity',
    )
  ) {
    return null;
  }

  return (
    <Banner
      className={className}
      variant="neutral"
      title={t('multiEntityHub.settings.marketingBanner.title')}
      actions={
        <Button
          variant="secondaryNeutral"
          text={t('multiEntityHub.settings.marketingBanner.actionText')}
          onClick={() => {
            history.push(
              routeFor(routes.ORGANISATION_COST_CENTERS.path, {
                company: companyId,
              }),
            );
          }}
        />
      }
    >
      <div>
        <Trans
          i18nKey="multiEntityHub.settings.marketingBanner.descriptionP1"
          components={{
            a: (
              <Link
                className="text-content-primary underline"
                href={routeFor(routes.ORGANISATION_COST_CENTERS.path, {
                  company: companyId,
                })}
                target="_self"
                rel="noreferrer"
              >
                -
              </Link>
            ),
          }}
        />

        <br />
        {t('multiEntityHub.settings.marketingBanner.descriptionP2')}
      </div>
    </Banner>
  );
};
